/**
 * DezLin — Theme enhancements
 *  1) Replace the modal-trigger search icon with an inline search input bar
 *     (320px wide on desktop, full row on mobile). Submits to /search.
 *  2) Shopify Inbox chat bubble: draggable along screen edges so it never
 *     blocks the cart subtotal or other UI elements.
 */
(function () {
  'use strict';

  function initInlineSearch() {
    // On mobile (<750px), keep Be Yours' native predictive-search modal — don't inject
    // inline bar AND don't hide the native modal. Native search has live results.
    if (window.innerWidth < 750) {
      // If we previously injected an inline-search and user resized down, clean it up
      document.querySelectorAll('.dz-inline-search').forEach(function (el) { el.remove(); });
      // And restore any modal we may have hidden
      document.querySelectorAll('search-modal[data-dz-enhanced="1"]').forEach(function (modal) {
        modal.style.display = '';
        modal.removeAttribute('data-dz-enhanced');
      });
      return;
    }
    var modals = document.querySelectorAll('search-modal');
    if (!modals.length) return;
    modals.forEach(function (modal) {
      // Skip if we've already enhanced this one
      if (modal.dataset.dzEnhanced === '1') return;
      modal.dataset.dzEnhanced = '1';

      var form = document.createElement('form');
      form.action = '/search';
      form.method = 'get';
      form.role = 'search';
      form.className = 'dz-inline-search';
      form.innerHTML = ''
        + '<button type="submit" class="dz-inline-search__btn" aria-label="Search">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        + '<circle cx="11" cy="11" r="7"></circle>'
        + '<line x1="21" y1="21" x2="16.65" y2="16.65"></line>'
        + '</svg>'
        + '</button>'
        + '<input type="search" name="q" class="dz-inline-search__input" placeholder="Search products…" autocomplete="off">';

      modal.parentNode.insertBefore(form, modal);
      modal.style.display = 'none';
    });
  }

  // Re-run on resize to handle desktop ↔ mobile transitions cleanly
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initInlineSearch, 200);
  });

  // ── Draggable Shopify Inbox chat bubble ─────────────────────────────────────
  // Hold and drag the chat icon to any position so it never blocks the cart.
  // Position is remembered across pages via localStorage.
  function initDraggableChat() {
    var STORAGE_KEY = 'dz-chat-pos';
    var chatEl = null;
    var drag = null;

    function applyStoredPosition(el) {
      try {
        var saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
        if (saved && typeof saved.bottom === 'number' && typeof saved.right === 'number') {
          el.style.bottom = saved.bottom + 'px';
          el.style.right  = saved.right  + 'px';
          el.style.top    = 'auto';
          el.style.left   = 'auto';
        }
      } catch (e) {}
    }

    function getXY(e) {
      var src = (e.touches && e.touches[0]) || e;
      return { x: src.clientX, y: src.clientY };
    }

    function attachDrag(el) {
      if (el._dzDragInit) return;
      el._dzDragInit = true;
      el.style.cursor = 'grab';
      applyStoredPosition(el);

      function onStart(e) {
        if (el.getAttribute('is-open') === 'true') return;
        var p = getXY(e);
        drag = {
          startX:      p.x,
          startY:      p.y,
          startRight:  parseFloat(el.style.right)  || 16,
          startBottom: parseFloat(el.style.bottom) || 80,
          moved: false
        };
        el.style.cursor = 'grabbing';
      }

      function onMove(e) {
        if (!drag) return;
        var p  = getXY(e);
        var dx = p.x - drag.startX;
        var dy = p.y - drag.startY;
        if (Math.abs(dx) > 10 || Math.abs(dy) > 10) drag.moved = true;
        if (!drag.moved) return;

        var elW = el.offsetWidth  || 65;
        var elH = el.offsetHeight || 65;
        // right  decreases when dragging right (dx positive) ✓
        // bottom decreases when dragging down  (dy positive) ✓
        var newRight  = Math.max(0, Math.min(window.innerWidth  - elW - 4, drag.startRight  - dx));
        var newBottom = Math.max(0, Math.min(window.innerHeight - elH - 4, drag.startBottom - dy));

        el.style.right  = newRight  + 'px';
        el.style.bottom = newBottom + 'px';
        el.style.top    = 'auto';
        el.style.left   = 'auto';
        e.preventDefault();
      }

      var wasDragging = false;

      function onEnd(e) {
        if (!drag) return;
        if (drag.moved) {
          wasDragging = true;
          // Prevent the synthetic click iOS fires after touchend
          e.preventDefault();
          try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({
              bottom: parseFloat(el.style.bottom) || 80,
              right:  parseFloat(el.style.right)  || 16
            }));
          } catch (_) {}
        }
        el.style.cursor = 'grab';
        drag = null;
      }

      // Suppress the click that fires after a drag ends — but never block clicks when chat is open
      el.addEventListener('click', function (clickEvt) {
        if (wasDragging && el.getAttribute('is-open') !== 'true') {
          wasDragging = false;
          clickEvt.stopImmediatePropagation();
          clickEvt.preventDefault();
        } else {
          wasDragging = false;
        }
      }, true);

      // Mouse
      el.addEventListener('mousedown',  onStart);
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup',   onEnd);
      // Touch — passive:false so we can preventDefault and stop page scroll
      el.addEventListener('touchstart', onStart, { passive: false });
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('touchend',  onEnd,  { passive: false });
    }

    function findAndAttach() {
      var el = document.querySelector('inbox-online-store-chat');
      if (el && el !== chatEl) { chatEl = el; attachDrag(el); }
    }

    // Force chat closed on initial load — Shopify Inbox can auto-open and feels intrusive.
    // Fixed timeouts only: MutationObserver approach also blocked user-intentional taps.
    function forceClosedOnLoad() {
      [500, 1500, 3000].forEach(function (delay) {
        setTimeout(function () {
          var el = document.querySelector('inbox-online-store-chat');
          if (!el) return;
          if (el.getAttribute('is-open') === 'true') {
            if (typeof el.close === 'function') { el.close(); return; }
            el.setAttribute('is-open', 'false');
          }
        }, delay);
      });
    }

    findAndAttach();
    forceClosedOnLoad();
    new MutationObserver(findAndAttach).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initInlineSearch();
      initDraggableChat();
    });
  } else {
    initInlineSearch();
    initDraggableChat();
  }
  document.addEventListener('shopify:section:load', initInlineSearch);
})();

